import { parseClipboardText } from '../core/paste-parser'
import { resolveBlockType } from './blocks-registry'

/** @type {Record<string, { canHandlePaste: Function, transformPaste: Function }>} */
const registry = {}

/**
 * @param {string} blockType
 * @param {{ canHandlePaste: (parsed: object) => boolean, transformPaste: (parsed: object, currentData: object) => object }} handler
 */
export function registerPasteHandler(blockType, handler) {
  registry[blockType] = handler
}

export function getPasteHandler(blockType) {
  const resolved = resolveBlockType(blockType)
  return registry[resolved] ?? registry[blockType] ?? null
}

/**
 * @param {string} blockType
 * @param {string} rawText
 * @param {object} currentData
 * @returns {object|null}
 */
export function handlePaste(blockType, rawText, currentData, focus = null) {
  const parsed = parseClipboardText(rawText)
  const handler = getPasteHandler(blockType)
  if (!handler) return null
  if (!handler.canHandlePaste(parsed)) return null
  return handler.transformPaste(parsed, currentData, focus)
}

export function isAmbiguousPaste(blockType, parsed) {
  if (parsed.type !== 'multiline') return false
  const resolved = resolveBlockType(blockType)
  return ['block_rule', 'block_card', 'block_supporting_notes', 'block_steps'].includes(
    resolved,
  )
}

export { parseClipboardText }
